import React, { memo, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import equal from 'fast-deep-equal';
import { XCircle } from 'react-feather';
import { Button, Col, Row } from 'react-bootstrap';
import { filterAnomaly, uniqueAanValues } from '../../utils/commonFunctions';
import DropdownSelect from '../common/dropDown';

//Function 1: unique values for everything except aan_value
function uniqueList(anomaly, key) {
  let lookup = {};
  let result = [];
  for (let item, i = 0; (item = anomaly[i++]); ) {
    let name = item[key];
    if (!(name in lookup)) {
      lookup[name] = 1;
      result.push({ key: name, value: name, text: name, label: name });
    }
  }
  return result;
}

//Main return function
function FilterPane(props) {
  const { show, data: anomaly, filter, handleClose, submitSelection } = props;

  const data = {
    aan_month: { data: uniqueList(anomaly, 'aan_month'), name: 'Month & Year' },
    kpi_name: { data: uniqueList(anomaly, 'kpi_name'), name: 'KPI Name' },
    owner: { data: uniqueList(anomaly, 'owner'), name: 'Owner' },
    severity: { data: uniqueList(anomaly, 'severity'), name: 'Severity' },
    status: { data: uniqueList(anomaly, 'status'), name: 'Status' },
    anomaly_type: {
      data: uniqueList(anomaly, 'anomaly_type'),
      name: 'Anomaly Type'
    }
  };
  const aan_value = uniqueAanValues(anomaly);

  const [selection, setSelection] = useState(filter);

  let filteredAlerts =
    Object.keys(selection).length !== 0
      ? filterAnomaly(anomaly, selection)
      : anomaly;

  const handleChange = (keyvalue, value) => {
    let sel = { ...selection };
    if (value.length === 0) delete sel[keyvalue];
    else sel[keyvalue] = value;
    setSelection(sel);
  };

  const onSubmit = (selection) => {
    sessionStorage.setItem('currentPage', 1);
    sessionStorage.setItem('filter', JSON.stringify(selection));
    submitSelection(selection);
    handleClose();
  };

  const clearSelection = () => {
    setSelection({});
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size='lg'
        aria-labelledby='contained-modal-title-vcenter'
        className='filterPane'
        centered
      >
        <h6 style={{ margin: '0 0 1rem 0' }}>Filter your perferences</h6>
        <Row className='m-0 generalFilter'>
          {Object.keys(data).map((key, i) => (
            <Col xs={12} md={4} lg={4} className='filterbox' key={i}>
              <h6 style={{ fontSize: '0.85rem' }}>{data[key]['name']}</h6>
              <DropdownSelect
                id={key}
                value={selection[key] || []}
                options={data[key]['data']}
                placeholder={`Select ${data[key]['name']}`}
                onChange={(e) => handleChange(key, e)}
                customclass='reactfilterbox'
              />
            </Col>
          ))}
        </Row>
        <h6 style={{ margin: '1rem 0' }}>Dimensional Filters</h6>
        <Row className='m-0 dimFilter'>
          {Object.keys(aan_value).map((key, i) => (
            <Col xs={12} md={4} lg={4} className='filterbox' key={i}>
              <h6 style={{ fontSize: '0.85rem' }}>
                {key.charAt(0).toUpperCase() + key.slice(1)}
              </h6>
              <DropdownSelect
                id={key}
                value={selection[key] || []}
                options={aan_value[key]}
                placeholder={`Select ${key}`}
                onChange={(e) => handleChange(key, e)}
                customclass='reactfilterbox'
              />
            </Col>
          ))}
        </Row>
        <Row
          className='m-0 mt-3 dimFilter'
          style={{ justifyContent: 'flex-end' }}
        >
          <p className='m-0 mr-3 filtermatch'>
            Found {filteredAlerts.length} results
          </p>
          <Button
            variant='warning'
            className='ml-2'
            onClick={clearSelection}
            style={{ padding: '0 1rem' }}
            disabled={Object.keys(selection).length === 0 ? true : false}
            title='Clear selection'
          >
            <XCircle size={18} />
          </Button>
          <Button
            variant='primary'
            className='ml-2'
            onClick={() => onSubmit(selection)}
            disabled={filteredAlerts.length === 0 ? true : false}
          >
            Apply
          </Button>
          <Button variant='danger' className='ml-2' onClick={handleClose}>
            Cancel
          </Button>
        </Row>
      </Modal>
    </>
  );
}

const isStateHeaderCellEqual = (prevProps, currProps) => {
  if (!equal(prevProps.show, currProps.show)) {
    return false;
  } else {
    return true;
  }
};

export default memo(FilterPane, isStateHeaderCellEqual);
